import { get, map } from 'lodash';
import { FaqCategory } from './faq-category';

interface IDeserializable {
  deserialize(input: any): this;
}

export class Faq implements IDeserializable {
  id?: string;
  heading?: string;
  subHeading?: string;
  isActive?: boolean;
  updatedAt?: string;
  categories?: FaqCategory[];
  dateFormat?: string;

  constructor() {
    this.dateFormat = 'dd MMMM, yyyy';
  }

  deserialize(input: any): this {
    this.id = get(input, 'id');
    this.heading = get(input, 'heading');
    this.subHeading = get(input, 'subHeading');
    this.updatedAt = get(input, 'legalApprovedDate');

    this.categories = this.buildCategories(get(input, 'category', []));
    return this;
  }

  private buildCategories(input: any[]) {
    if (!input.length) return [];

    const tempCategories: FaqCategory[] = map(input, (category) => {
      return new FaqCategory().deserialize(category);
    });
    return tempCategories;
  }
}
